import React, { useState } from 'react';
import EasyUploadLinkModal from '@features/Modals/EasyUploadLinkModal';
import { translate } from '@utils/i18n';
function EasyUploadLink({ subcontractWorkStatusId }) {
    const namespace = 'features.modals.easy_upload_link_modal';
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", "aria-label": "easy_upload_link", className: "qmb-control--icon", title: translate('easy_upload_link', { namespace }), onClick: handleClick },
            React.createElement("i", { className: "fa-light fa-link" })),
        open && React.createElement(EasyUploadLinkModal, { subcontractWorkStatusId: subcontractWorkStatusId, onClose: handleClose })));
}
export default EasyUploadLink;
